export default "__VITE_ASSET__xRpVxeqT__"